import { render, staticRenderFns } from "./NewHobbiePopup.vue?vue&type=template&id=5218bc65&"
import script from "./NewHobbiePopup.vue?vue&type=script&lang=js&"
export * from "./NewHobbiePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports